import { render, staticRenderFns } from "./BatchImport.vue?vue&type=template&id=27c17da1&scoped=true"
import script from "./BatchImport.vue?vue&type=script&lang=js"
export * from "./BatchImport.vue?vue&type=script&lang=js"
import style0 from "./BatchImport.vue?vue&type=style&index=0&id=27c17da1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c17da1",
  null
  
)

export default component.exports